import { useState } from 'react';
import Icon, { ICON_NAME } from "../../components/Icon";
import LoadingBox from "../../components/LoadingBox";
import Menu from "../../components/Menu";
import modal from "../../components/Popup/ModalCustom";
import { showErrorResponse } from "../../util/varibles/global";
import { notify, NotifyCode } from "../../util/varibles/message";
import styles from './style.module.scss';

interface IProps<S> {
    data: S

    onEdit?(data: S): void

    onDelete?: (id: string) => Promise<any>

    afterDelete?(id: string): void
}

function Action<S extends ({ id?: string, name?: string })>({ data, onEdit, onDelete, afterDelete }: IProps<S>) {
    const [loading, setLoading] = useState(false);

    const handleDelete = () => {
        if (loading)
            return;
        modal.confirm({
            content: `Are you sure delete ${data.name}?`,
            ok: {
                click: () => {
                    if (!onDelete)
                        return;
                    setLoading(true);
                    const id = data.id || '';
                    onDelete(id)
                        .then(() => {
                            setLoading(false);
                            notify.success(NotifyCode.S4)([data.name]);
                            afterDelete?.(id);
                        })
                        .catch(error => {
                            setLoading(false);
                            showErrorResponse(notify[NotifyCode.E36]([data.name]), error)
                        })
                }
            }
        })
    }

    return <div className={styles.action}>
        <Menu
            disabled={loading}
            placement='bottomRight'
            items={[
                onEdit ? {
                    key: 'edit',
                    label: <div className='menu-line' onClick={() => onEdit(data)}>
                        <Icon icon={ICON_NAME.EDIT} />
                        <div data-lev='name'>Edit</div>
                    </div>
                } : {},
                onDelete ? {
                    key: 'delete',
                    disabled: loading,
                    label: <div className='menu-line' data-danger={true} onClick={handleDelete}>
                        {loading ? <LoadingBox loading={true} spinnerSize={18} /> : <Icon icon={ICON_NAME.DELETE} />}
                        <div data-lev='name'>Delete</div>
                    </div>
                } : {}
            ]}>
            <div className='three-dot' />
        </Menu>
    </div>;
}

export default Action;